import React from "react";
import { TouchableOpacity } from "react-native";
import {
  Typography,
  Box,
  Stack,
  Spacer,
  Divider,
  Button,
} from "digiwash-components";
import { formatNumber } from "digiwash-core";

import {
  generateDescriptionByStatus,
  generateColorByStatus,
} from "./OrderItem-helpers";
import styled from "styled-components/native";
import { color } from "@sloth-system/styled-utils";

import { Order, OrderLatestStatus } from "../../types/server";
import Icon from "../Icon";
import useNavigation from "../../hooks/useNavigation";

const Container = styled(Box)`
  border: 2px solid ${({ borderColor, ...props }) => color(borderColor)(props)};
  overflow: hidden;
`;

interface PropTypes {
  data: Order;
}

function OrderItem(props: PropTypes) {
  let nav = useNavigation();

  let details = generateDescriptionByStatus(props.data);
  let colors = generateColorByStatus(props.data);

  let needsAction = props.data.latest_status == OrderLatestStatus.WorkDone;

  let handleOnPress = () => {
    nav.jumpAndNavigate({
      jumpTo: "Orders",
      navigateTo: "OrderView",
      navigateParams: {
        order_id: props.data.id,
      },
    });
  };
  return (
    <TouchableOpacity onPress={handleOnPress}>
      <Container br="l" borderColor={colors.cardColor}>
        <Stack p="l" bg={colors.cardColor} distribution="space-between">
          <Typography color="neutrals.800">
            شماره سفارش {formatNumber(props.data.id)}
          </Typography>
          <Stack>
            <Typography ff="mainMedium" color="primary.main">
              مشاهده جزییات
            </Typography>
            <Spacer size="m" />
            <Icon name="chevron-left" size={16} color="primary.main" />
          </Stack>
        </Stack>
        <Box bg="primary.light950" p="l">
          <Typography
            alignment="center"
            color={colors.textColor.main}
            fs="m"
            ff="mainBold"
          >
            {details.title}
          </Typography>
          <Divider size="m" />
          <Typography
            alignment="center"
            fs="xm"
            color={colors.textColor.description}
          >
            {details.description}
          </Typography>
          {needsAction && (
            <>
              <Divider size="l" />
              <Button outline onPress={handleOnPress}>
                تنظیم زمان و محل تحویل
              </Button>
            </>
          )}
        </Box>
      </Container>
    </TouchableOpacity>
  );
}

export default OrderItem;
